import { render, staticRenderFns } from "./AreaTrabajo.vue?vue&type=template&id=216fd89c"
import script from "./AreaTrabajo.vue?vue&type=script&lang=js"
export * from "./AreaTrabajo.vue?vue&type=script&lang=js"
import style0 from "./AreaTrabajo.vue?vue&type=style&index=0&id=216fd89c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports